module.exports = __webpack_public_path__ + "media/fonts/SFProText-Semibold-1de42b5b6a3db03e4c414976d04f4151.svg";